import React from 'react';
import zapier from '../../images/integrations/zapier.png';
import IntegrationBot from '../../components/integrationn/index';

const ZapierPage = () => <IntegrationBot botLogo={zapier} botName={'Zapier'} />;

export default ZapierPage;
